import * as React from "react";
const SvgFiRrMonday = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-monday_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-1V1a1 1 0 1 0-2 0v1H8V1a1 1 0 0 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 1.526.684 2.948 1.875 3.902a.996.996 0 0 0 1.406-.155 1 1 0 0 0-.156-1.405A2.99 2.99 0 0 1 2 19v-9h20v3a1 1 0 1 0 2 0V7c0-2.757-2.243-5-5-5M2 8V7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v1zm9.992 9 .445 6.142a.8.8 0 1 1-1.596.116l-.265-3.66-.798 1.756a.855.855 0 0 1-1.557 0l-.798-1.756-.265 3.66a.8.8 0 0 1-1.596-.116L6.007 17c.043-.705.472-1 .988-1 .342 0 .66.242.841.64L9 19.2l1.164-2.56c.181-.398.499-.64.841-.64.516 0 .945.295.988 1zM24 16.8v6.23a.97.97 0 0 1-1.856.394L20.6 19.946V23.2a.8.8 0 1 1-1.6 0v-6.226a.969.969 0 0 1 1.854-.393l1.546 3.482V16.8a.8.8 0 1 1 1.6 0m-8.3-.8a2.3 2.3 0 0 0-2.3 2.3v3.4c0 1.269 1.031 2.3 2.3 2.3s2.3-1.031 2.3-2.3v-3.4c0-1.269-1.031-2.3-2.3-2.3m.7 5.7a.7.7 0 0 1-1.4 0v-3.4a.7.7 0 0 1 1.4 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-monday_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMonday;
